export default __webpack_public_path__ + "1.18.25/static/media/libreLinkUp-small-ar.34ac38f7.svg";